<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2">عنوان المحافظة</h5>

                       <span> بالرجاء ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "governorateForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                          
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم المحافظة</label>
                                <input class="form-control"  id="validation01" type="text" formControlName="TitleAr"
                                [tooltip]="fc.TitleAr.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.TitleAr.valid && (fc.TitleAr.touched)"
                                [class.is-invalid]="fc.TitleAr.invalid && (fc.TitleAr.touched)"
                                     required
                                     placeholder="اسم المحافظة"
                                    containerClass="" />
                            </div>
                            <!-- <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span>اسم المحافظة باللغه الانجليزيه </label>
                                <input class="form-control" appDisableWeritingArabic id="validation01" type="text" formControlName="Title"
                                [tooltip]="fc.Title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.Title.valid && (fc.Title.touched)"
                                [class.is-invalid]="fc.Title.invalid && (fc.Title.touched)"
                                     required
                                     placeholder="اسم المحافظة باللغه الانجليزيه"
                                    containerClass="" />
                            </div> -->
                             <div class="col-6 mb-3">
                                <label for="validationCustom05"><span class="validation-required">*</span> الدولة </label>
                                <ng-select #Governorate  [selectOnTab]="true" formControlName="countryId"
                                    class="form-control p-0" placeholder="اختر الدولة"
                                    containerClass="" 
                                    id="validationCustom05">
                                    <ng-option *ngFor="let item of countries" [value]="item.id">{{item.titleAr}}</ng-option>
                                </ng-select>
                            </div>
                         
                        </div>
                        
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

